import {
  REQUEST_UTM_FORM_FILTERS,
  REQUEST_UTM_FORM_FILTERS_SUCCEEDED,
  REQUEST_UTM_FORM_FILTERS_FAILED,
  REQUEST_UTM_FORM_CREATE_LEAD,
  REQUEST_UTM_FORM_CREATE_LEAD_SUCCEEDED,
  REQUEST_UTM_FORM_CREATE_LEAD_FAILED,
} from './action-types';

import utils from '../utils';

const initialState = {
  data: [],
  totals: {},
  loading: false,
};

const utmFormsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case REQUEST_UTM_FORM_FILTERS:
    case REQUEST_UTM_FORM_CREATE_LEAD: {
      return {
        ...state,
        loading: true,
      };
    }
    case REQUEST_UTM_FORM_FILTERS_SUCCEEDED: {
      const {
        data, pages, bindingObject: { filters },
      } = action;
      return {
        ...state,
        utmForms: data,
        filters,
        pages,
        loading: false,
      };
    }
    case REQUEST_UTM_FORM_FILTERS_FAILED: {
      utils.dialog({
        type: 'warning',
        title: 'Error inesperado',
        message: 'No se ha podido recoger los ciclos, ha ocurrido un error.',
      });
      return {
        ...state,
        loading: false,
      };
    }
    case REQUEST_UTM_FORM_CREATE_LEAD_SUCCEEDED: {
      utils.dialog({
        type: 'reload',
        title: 'Lead Creado',
        message: 'El Lead se ha creado correctamente',
      });
      return {
        ...state,
        loading: false,
      };
    }
    case REQUEST_UTM_FORM_CREATE_LEAD_FAILED: {
      utils.dialog({
        type: 'warning',
        title: 'Error inesperado',
        message: 'No se ha podido guardar el Lead, recuerda todos los campos son obligatorios.',
      });
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default utmFormsReducer;
